import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '@/app/hooks'
import { selectUser } from '@/features/auth/authSlice'
import {
  screenNameFromPath,
  sendPageLoadingTiming,
  setAnalyticsUser,
  setScreenView,
} from '@/lib/utils/analytics'

/**
 * Angular AppService + LayoutComponent analytics: user_id, screen_view, load timing.
 */
export function AnalyticsTracker() {
  const location = useLocation()
  const user = useAppSelector(selectUser)
  const loadStartRef = useRef(performance.now())

  useEffect(() => {
    setAnalyticsUser()
  }, [user?.user_id])

  useEffect(() => {
    loadStartRef.current = performance.now()
    const screenName = screenNameFromPath(location.pathname)
    if (screenName) {
      setScreenView(screenName)
    }
    const start = loadStartRef.current
    const id = window.requestAnimationFrame(() => {
      sendPageLoadingTiming(performance.now() - start)
    })
    return () => window.cancelAnimationFrame(id)
  }, [location.pathname])

  return null
}
